<template>
    <el-form
        ref="UpdateProfileForm"
        :model="userProfile"
        status-icon
        @submit="saveProfileModifications"
        @keyup.enter.native="saveProfileModifications"
    >
        <el-form-item :label="getVerbose('profile_identity_form_label_email')">
            <el-input
                v-model="$store.state.api.auth.user.email"
                type="text"
                disabled
            ></el-input>
        </el-form-item>
        <el-form-item :label="getVerbose('profile_identity_form_label_first_name')">
            <el-input
                v-model="userProfile.first_name"
                type="text"
            ></el-input>
        </el-form-item>
        <el-form-item :label="getVerbose('profile_identity_form_label_last_name')">
            <el-input
                v-model="userProfile.last_name"
                type="text"
            ></el-input>
        </el-form-item>
    </el-form>
</template>

<script>

import {mapGetters} from 'vuex';

export default {

    components: {
    },

    props: {
        user: {
            type: Object,
            required: true,
        }
    },

    data: function(){
        return {
            userProfile: {
                uid: '',
                url: '',
                first_name: '',
                last_name: ''
            },
        };
    },

    computed: {
        ...mapGetters('fundation', [
            'getVerbose'
        ])
    },

    watch:{
        '$store.state.api.selfUserLoaded': function(){
            this.loadUser();
        },
        'user': function(){
            this.loadUser();
        }
    },

    mounted: function(){
        this.loadUser();
    },

    methods: {
        loadUser(){
            if(!this.user){
                return;
            }
            this.userProfile.uid = this.user.uid;
            this.userProfile.url = this.user.url;
            this.userProfile.first_name = this.user.first_name;
            this.userProfile.last_name = this.user.last_name;
        },

        saveProfileModifications() {
            // code here will save the modifications for the profile

            /* can be called by parent by using a reference
                the reference should be on the called component
                this.$refs[REF_ON_COMPONENT]saveProfileModifications();*/
            this.$store.dispatch('patchItem', {
                item: this.userProfile,
                model: 'selfUser'
            }).then(() => {
                this.$notify.success({
                    title: this.getVerbose('profile_identity_save_successfull_title'),
                    message: this.getVerbose('profile_identity_save_successfull_message'),
                });
            }).catch((error)=>{
                this.$notify.warning({
                    title: this.getVerbose('profile_identity_save_failed_title'),
                    message: this.getVerbose('profile_identity_save_failed_message'),
                });
                console.error(error);
            });
        },
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/pages/user-profile/profile-form.vue